import { useState, useEffect } from "react";
import { Space, Divider, Switch, Flex, message, Skeleton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RightOutlined } from "@ant-design/icons";

// Constants

// Components
import AvatarIcon from "../AvatarIcon";

// Styles
import cs from "./index.module.css";
import "../../../index.css";

// Redux Actions
import * as REDUX_ACTION from "../../../../services/redux/actions";
import { REDUX as REDUX_UTIL } from "../../../../services/util";

const { reduxStoreWrapper } = REDUX_UTIL;

const PageHeaderBar = () => {
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();

  const loading = useSelector(reduxStoreWrapper("style.loading.general"));
  const user = useSelector(reduxStoreWrapper("user"));
  const company = useSelector(reduxStoreWrapper("company.byCOID"));
  const isAdmin = user.uroleid === "A";

  const isDisabled = company?.isBlocked === -1;
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const req_status = company?.isBlocked === 0 ? true : false;
    if (user.uroleid === "EMR") {
      setIsEnabled(req_status);
    }
  }, [company?.isBlocked]);

  useEffect(() => {
    if (user.uroleid === "EMR") {
      dispatch(
        REDUX_ACTION.v1_company.get_company_thru_coid_request(user.coid)
      );
    }
    return () => {};
  }, [dispatch, user]);

  const toggleSwitch = (checked) => {
    if (!isDisabled) {
      const req = isEnabled ? 1 : 0;
      messageApi.open({
        type: "loading",
        content: "Updating request status company...",
        duration: 0,
      });
      dispatch(
        REDUX_ACTION.v1_company.update_company_request(
          {
            coid: company.coid,
            updatedBy: user.memid,
            items: { ...company, isBlocked: req },
          },
          ({ status, msg, err }) => {
            if (status === 200) {
              setIsEnabled(checked);
              message.success("Requst status company successfully updated");
            } else {
              message.error(err);
            }
            messageApi.destroy();
          }
        )
      );
    } else {
      message.error(
        "The request status is disabled. The employer cannot perform the update."
      );
    }
  };

  return (
    <>
      {contextHolder}
      <div className={cs["header-content-right"]}>
        <div className={cs["profile-container"]}>
          {loading ? (
            <Skeleton active/>
          ) : (
            <Space>
              {/* {!isAdmin ? (
                <Space>
                  <Flex vertical style={{ textAlign: "left" }}>
                    <span style={{ color: "#878787", marginBottom: "5px" }}>
                      Overdue/ Total Unpaid Amount
                    </span>
                    <Flex style={{ marginTop: "5px" }}>
                      <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                        RM 10,000/ RM 20,000{" "}
                      </span>
                      <RightOutlined />
                    </Flex>
                  </Flex>
                  <Divider type="vertical" style={{ height: "35px" }} />
                </Space>
              ) : (
                <div></div>
              )} */}

              {!isAdmin ? (
                <Space style={{ alignItems: "start" }}>
                  <Flex vertical>
                    <span style={{ color: "#878787" }}>Request Status</span>
                    <Flex>
                      <span
                        style={{
                          marginRight: "8px",
                          marginTop: "10px",
                          color: isEnabled
                            ? "#34C759"
                            : isDisabled
                            ? "grey"
                            : "red",
                          fontWeight: "600",
                        }}
                      >
                        {isEnabled
                          ? "Enable"
                          : isDisabled
                          ? "Disabled"
                          : "Suspend"}
                      </span>
                      <Switch
                        style={{
                          "--height": "5px",
                          "--top": "-9px",
                          "--bg-before-color": "gray",
                          "--before-color": isEnabled
                            ? "#2AA248"
                            : isDisabled
                            ? "grey"
                            : "orange",
                          marginTop: "16.5px",
                        }}
                        // style={{ marginTop: "16.5px" }}
                        checked={isEnabled}
                        onChange={toggleSwitch}
                      />
                    </Flex>
                  </Flex>
                  <Divider type="vertical" style={{ height: "35px" }} />
                </Space>
              ) : (
                <div></div>
              )}
              <AvatarIcon />
              <Flex vertical style={{textAlign: "left"}}>
                {user?.uroleid === "EMR" && <span style={{marginTop: "-2px", marginBottom: "7px"}}>{user?.name}</span>}
                <p className={cs.name} style={{ color: "#878787" }}>
                  {user?.uroleid === "A" ? user?.name : company?.name}
                </p>
              </Flex>
              
            </Space>
          )}
        </div>
      </div>
    </>
  );
};

export default PageHeaderBar;
